import { atom } from "jotai";
import tools_tools from "../../../data/projects/enums/projects_tools_tools";
import moment from "moment";

const toolsExperienceAtom = atom([]);
toolsExperienceAtom.debugLabel = "Tools Experience";

const toolsExperienceOptionViewsAtom = atom(
  tools_tools.reduce((acc: any, option: string) => {
    acc[option] = 1; // Initialize views for each option to 1
    return acc;
  }, {}),
);

const inputTextSearchAtom = atom("");
inputTextSearchAtom.debugLabel = "Input Text Search";
const labelsAtom = atom<string[]>([]);
labelsAtom.debugLabel = "Predicted Labels";

toolsExperienceOptionViewsAtom.debugLabel = "Tools Experience Option Views";

const projectTypeAtom = atom([]);
projectTypeAtom.debugLabel = "Project Type";

const productTypeAtom = atom([]);
productTypeAtom.debugLabel = "Product Type";

const offeredGratificationAtom = atom([]);
offeredGratificationAtom.debugLabel = "Offered Gratification";

const forGratificationAtom = atom([]);
forGratificationAtom.debugLabel = "For Gratification";

const softSkillsAtom = atom([]);
softSkillsAtom.debugLabel = "Soft Skills";

const requiredAreaOfExpertiseAtom = atom([]);
requiredAreaOfExpertiseAtom.debugLabel = "Required Area of Expertise";

const projectDeadlineAtom = atom(new Date(0));
projectDeadlineAtom.debugLabel = "Project Deadline";

const hardSkillsAtom = atom([]);
hardSkillsAtom.debugLabel = "Hard Skills";


const offeredWorkingTypeAtomNewArray = atom([]);
offeredWorkingTypeAtomNewArray.debugLabel = "Offered Working Type";

const offeredWorkingTypeActiveOptionsAtom = atom([]);
offeredWorkingTypeActiveOptionsAtom.debugLabel =
  "Offered Working Type Active Options";

const usedLanguagesAtom = atom([]);
usedLanguagesAtom.debugLabel = "Used Languages";

const locationsAtom = atom([]);
locationsAtom.debugLabel = "Locations";

const bizOrTechRoleAtomLeftValue = atom("");
bizOrTechRoleAtomLeftValue.debugLabel = "Required Biz Or Tech Role Left Value";

const bizOrTechRoleAtomRightValue = atom("");
bizOrTechRoleAtomRightValue.debugLabel =
  "Required Biz Or Tech Role Right Value";

const requiredAvailabilityAtomStartValue = atom(0);
requiredAvailabilityAtomStartValue.debugLabel =
  "Required Availability Start Value";

const requiredAvailabilityAtomEndValue = atom(0);
requiredAvailabilityAtomEndValue.debugLabel = "Required Availability End Value";

const requiredAvailabilityAtomOption = atom("");
requiredAvailabilityAtomOption.debugLabel = "Required Availability Option";

const projectDeadlineAtomOption = atom("");
projectDeadlineAtomOption.debugLabel = "Project Deadline Option";


// opening atoms!
const openAtom = atom({
  inputTextSearch: false,
  toolsExperience: false,
  projectType: false,
  productType: false,
  offeredGratification: false,
  forGratification: false,
  softSkills: false,
  requiredAreaOfExpertise: false,
  projectDeadline: false,
  hardSkills: false,
  offeredWorkingType: false,
  usedLanguages: false,
  bizOrTech: false,
  requiredAvailability: false,
  locations: false,
});

openAtom.debugLabel = "Open Project Filters"

export {
  labelsAtom,
  inputTextSearchAtom,
  toolsExperienceAtom,
  toolsExperienceOptionViewsAtom,
  projectTypeAtom,
  productTypeAtom,
  offeredGratificationAtom,
  forGratificationAtom,
  softSkillsAtom,
  requiredAreaOfExpertiseAtom,
  projectDeadlineAtom,
  hardSkillsAtom,
  offeredWorkingTypeAtomNewArray,
  offeredWorkingTypeActiveOptionsAtom,
  usedLanguagesAtom,
  bizOrTechRoleAtomLeftValue,
  bizOrTechRoleAtomRightValue,
  requiredAvailabilityAtomStartValue,
  requiredAvailabilityAtomEndValue,
  requiredAvailabilityAtomOption,
  projectDeadlineAtomOption,
  locationsAtom,
  openAtom
};
